// extracted by mini-css-extract-plugin
export default {"body":"body-dfuXe","header":"header-rP5Vz","close":"close-NSq4s","clickable":"clickable-F2tEM"};